module.exports = __webpack_public_path__ + "img/9788949192550.a75ba888.jpg";